import { checkSSO } from './check-sso';
import { Environment } from './environment.interface';

// Chat configurations to be used when in dev

export const environment: Environment = {
  production: true,
  intercom: 'w4v1419t',
  tasks: true,
  giftcardImport: true,
  customerImport: true,
  customerDeactivation: true,
  customerResetCredits: true,
  // Added this for testing purposes, will remove this afterwards
  googleAnalyticsTrackId: 'UA-108353784-1',
  giftcardsDelete: true,
  voidReasons: true,
  enableSSO: checkSSO(),
  authService: '/PosServer/rest/internal/v1/sso/login/manager',
  masUIscriptUrl:
    'https://ls-mfe-assets-cdn.lightspeedstg.app/merchant-account-space/v0/latest.js',
  masTestMode: false
};
